/**
 * Is string length less than or equal to `length`
 * @param {string} stringValue
 * @param {number} length
 * @returns {boolean}
 */
export const isStringLengthThanEqual = (stringValue, length) => {
  return stringValue.length <= length
}
